import { finleyAssertUnreachable } from '@finley-technologies/common';
import { progress } from '@finley-technologies/tape-builder';

import { DataPipelineNodeData } from 'packages/dataPipeline/types/dataPipelineTypes';

/** Errors to show in the bbpl monitor sidebar drawer for a graph node. */
export const getNodeErrors = ({
  nodes,
  artifactId,
}: {
  nodes: DataPipelineNodeData[];
  artifactId: string;
}): progress.AggregatedError[] => {
  const instance = nodes.find((n) => n.artifact.id === artifactId)?.instance;
  if (instance?.status !== 'error') {
    return [];
  }

  const errors: progress.AggregatedError[] = [];
  instance.statusDetails.errors.forEach((error) => {
    switch (error.type) {
      case 'structuredPublicError':
        errors.push({ ...error.content, type: 'structuredPublicError' });
        break;
      default:
        finleyAssertUnreachable(error.type);
    }
  });
  return errors;
};
